import { lazyForPaint } from 'react-loosely-lazy';
import { composeLinkPicker } from './main';
var LazyLinkPickerComponent = lazyForPaint(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_link-picker" */
  './link-picker').then(function (_ref) {
    var LinkPicker = _ref.LinkPicker;
    return {
      default: LinkPicker
    };
  });
});

// Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
export default composeLinkPicker(LazyLinkPickerComponent);